import { Box, Text } from "@chakra-ui/react";
import { currency, percent } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";

interface StatItemProps {
  label: string;
  value: number | string;
  percent: number | string;
}

const StatItem = (props: StatItemProps) => {
  return (
    <Box w="33.333%">
      <Text color="grey.500">{props.label}</Text>
      <Text mt="2" fontWeight="semibold">
        {currency.formatByWorkspace(props.value)}
        {` (${percent.format(props.percent)})`}
      </Text>
    </Box>
  );
};

export default observer(StatItem);
